<template>
	<div class="page customerService">
		<!-- customerService -->
		<section class="secWrap customerServiceWrap">
			<div class="topBgWrap" :style="topBgStyle"></div>
			<div class="pageContentWrap">
				<div class="pageTitleWrap">
					<p class="subTxt">{{this.customerService.top.subTxt.txt}}</p>
					<h2 class="titleTxt">{{this.customerService.top.title.txt}}</h2>
				</div>

				<div class="pageInnerContentHtmlWrap">
					<!-- 고객문의 -->
					<div class="pageCustomerWrap">
						<h3>개인정보 수집 및 이용 동의</h3>
						<div class="userAgreementText">
							<div class="userAgreementTextInner">
								<p>
									1. 개인정보의 수집 항목 및 이용 목적<br>
									(주)두손소프트 (이하 "회사")는 이용자들에게 보다 더 향상된 양질의 서비스를 제공하기 위하여 이용자 개인의 정보를 수집하고 있으며, 수집한 개인정보를 다음의 목적을 위하여 이용합니다.<br><br>

									가. 필수 항목 : 성명<br>
									- 고객문의 및 이용 불편사항 처리를 위한 이용자식별<br>
									나. 필수 항목 : 이메일 주소<br>
									- 문의사항 회신, 본인의사 확인, 불만 처리 등 의사소통 경로의 확보<br>
									다. 선택 항목 : 연락처<br>
									- 서비스를 제공하기 위한 자료<br>
									2. 회사가 수집하는 개인정보의 보유 및 이용기간<br>
									이용자의 개인정보는 수집 및 이용에 관한 동의 후 3개월간 개인정보를 보유하고, 이후 해당 정보를 지체 없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다.<br>
									가. 소비자의 불만 또는 분쟁 처리에 관한 기록 : 3년<br>
									나. 기타 개별적으로 이용자의 동의를 받은 경우 : 동의를 득한 기간까지<br>
									3. 회사가 수집하는 개인정보 수집방법<br>
									- 회사는 이용자들에게 서비스를 제공하기 위한 필수정보들을 온라인상에서 입력 받고 있습니다.<br>
									4. 귀하는 개인정보 수집·이용에 동의하지 않으실 수 있습니다. 그러나 동의하지 않을 경우 문의하기 서비스가 제한될 수 있습니다.
								</p>
							</div>
						</div>
						<div class="userAgreementCheck">
							<b-checkbox v-model="checked">개인정보 수집 및 이용에 동의 합니다.</b-checkbox>
						</div>
						<div class="informationInputWrap">
							<div class="informationInputHeader">
								<h3>고객정보</h3>
								<span class="require">*필수 입력 항목</span>
							</div>
							<div class="informationInputItem">
								<b-field label="이름" class="require">
									<div class="informationInputContent">
										<b-input size="is-medium" v-model="name" maxlength="20"></b-input>
									</div>
								</b-field>

								<b-field grouped class="emailGroup">
									<b-field label="이메일" class="require">
										<div class="informationInputContent">
											<b-input v-model="emailFirst"></b-input>
											<span class="at">@</span>
											<b-input v-model="emailSecond"></b-input>
											<b-select v-model="emailSecond" placeholder="직접입력" class="emailSelect">
												<option selected="selected" value="">직접입력</option>
												<option value="naver.com">naver.com</option>
												<option value="daum.net">daum.net</option>
												<option value="hanmail.net">hanmail.net</option>
												<option value="gmail.com">gmail.com</option>
												<option value="nate.com">nate.com</option>
												<option value="yahoo.co.kr">yahoo.co.kr</option>
												<option value="hotmail.com">hotmail.com</option>
											</b-select>
										</div>
									</b-field>
								</b-field>

								<b-field label="연락처">
									<div class="informationInputContent">
										<b-input v-model="phoneNumber" type="number" placeholder="숫자만 입력해 주세요."></b-input>
									</div>
								</b-field>
							</div>
							<div class="informationInputHeader">
								<h3>문의내용</h3>
								<span class="require">*필수 입력 항목</span>
							</div>
							<div class="informationInputItem">
								<b-field label="분야" class="categoryFieldWrap require">
									<div class="informationInputContent">
										<b-field class="categoryField">
											<p class="control">
												<b-radio-button type="is-dark" class="chainedRadioToggle" native-value="0" v-model="category">
													일반문의
												</b-radio-button>
											</p>
											<p class="control">
												<b-radio-button type="is-dark" class="chainedRadioToggle" native-value="1" v-model="category">
													사업/파트너십
												</b-radio-button>
											</p>
											<p class="control">
												<b-radio-button type="is-dark" class="chainedRadioToggle" native-value="2" v-model="category">
													채용
												</b-radio-button>
											</p>
										</b-field>
									</div>
								</b-field>
								<b-field label="제목" class="require withMessage">
									<div class="informationInputContent">
										<b-input v-model="subject" placeholder="내용 입력" maxlength="100"></b-input>
									</div>
								</b-field>

								<b-field label="내용" class="require textareaArticle withMessage">
									<div class="informationInputContent">
										<b-input type="textarea" v-model="txtContent" placeholder="내용 입력" maxlength="1500"></b-input>
									</div>
								</b-field>
							</div>
						</div>
						<div class="btnWrap">
							<b-button class="btnRegister" @click="sendForm">등록</b-button>
						</div>
					</div>
					<!-- //고객문의 -->
				</div>
			</div>
		</section>
		<Footer/>
	</div>
</template>

<script>
import AOS from 'aos'
import 'aos/dist/aos.css'
import Footer from '../components/Footer'

export default {
	name: 'CS',
	components: {
		Footer
	},
	data () {
		return {
			customerService: {
				background: {
					color: '#fff',
					image: require('@/assets/images/bg-customer-fcnote@2x.jpg'),
					size: 'cover',
					position: 'center center',
					width: '100%'
					// height: '284px'
				},
				top: {
					title: {
						txt: '고객문의',
						fontWeight: 'bold'
					},
					subTxt: {
						txt: 'Customer Service',
						fontWeight: 'normal'
					},
					image: {
						url: ''
					}

				},
				pageHeader: {
					title: {
						btns: [
							{
								txt: '체험하기',
								link: ''
							},
							{
								txt: '제품 소개서 다운로드',
								link: ''
							}
						],
						pos: 'bottom right'
					},
					subTxt: {
						txt: 'HTML5 기반 멀티 디바이스용<br>필기 메모 컴포넌트'
					},
					background: {
						color: '#781AA5',
						image: ''
					}
				}
			},
			checked: false,
			name: '',
			phoneNumber: '',
			emailFirst: '',
			emailSecond: '',
			category: '0',
			subject: '',
			txtContent: ''
		}
	},
	computed: {
		topBgStyle: function () {
			return {
				backgroundColor: this.customerService.background.color,
				backgroundImage: 'url(' + this.customerService.background.image + ')',
				// height: this.customerService.background.height,
				width: this.customerService.background.width,
				backgroundSize: this.customerService.background.size ? this.customerService.background.size : 'cover',
				backgroundPosition: this.customerService.background.position ? this.customerService.background.position : 'center center'
			}
		},
		pageHeaderStyle: function () {
			return {
				backgroundColor: this.customerService.pageHeader.background.color,
				backgroundImage: 'url(' + this.customerService.pageHeader.background.image + ')',
				height: this.customerService.pageHeader.background.height,
				width: this.customerService.pageHeader.background.width,
				backgroundSize: this.customerService.pageHeader.background.size ? this.customerService.pageHeader.background.size : 'cover',
				backgroundPosition: this.customerService.pageHeader.background.position ? this.customerService.pageHeader.background.position : 'center center'
			}
		},
		email: function () {
			if (this.emailFirst && this.emailSecond) {
				return this.emailFirst + '@' + this.emailSecond
			} else {
				return ''
			}
		}
	},
	mounted () {
		var cat = this.$route.query.category
		if (cat !== undefined) {
			this.category = cat
		}
	},
	created () {
		AOS.init({
			duration: 600,
			easing: 'ease-in-sine',
			delay: 100
		})
	},
	destroyed () {},
	methods: {
		sendForm () {
			if (!this.checked) {
				this.$buefy.dialog.alert('계속 진행하시려면 고객님의 동의가 필요합니다.')
			} else if (!this.name) {
				this.$buefy.dialog.alert('이름을 입력해주세요.')
			} else if (!this.emailFirst || !this.emailSecond) {
				this.$buefy.dialog.alert('이메일을 확인해 주세요.')
			} else if (!this.subject) {
				this.$buefy.dialog.alert('제목을 입력해주세요.')
			} else if (!this.txtContent) {
				this.$buefy.dialog.alert('내용을 입력해주세요.')
			} else {
				this.$axios.post(this.$store.state.dataUrl + '/sendTwosonContactUs', {
					name: this.name,
					email: this.email,
					phoneNm: this.phoneNumber,
					cate: this.category,
					title: this.subject,
					content: this.txtContent
				})
					.then(response => {
						this.$buefy.dialog.alert({
							message: '입력하신 내용이 전달 완료되었습니다.',
							onConfirm: () => { this.$router.push('/') }
						})
						console.log('historyData : ' + response.data)
					})
					.catch(error => {
						this.$buefy.dialog.alert({
							message: '죄송합니다. 서비스 장애입니다.<br>전화로 문의 바랍니다.<br>감사합니다.'
						})
						console.log('* error : ' + error.response)
					})
			}
		}
	}
}
</script>

<style lang="scss">
@import '@/css/variables.scss';
.customerService {
	.customerServiceWrap {
		.pageContentWrap {
			.pageInnerContentHtmlWrap {
				.pageCustomerWrap {
					.informationInputWrap {
						.informationInputItem {
							.field {
								display:flex;
								align-items:center;
								flex-basis:100%;
								height: auto;
								margin:0; padding: 12px 0;
								&:not(:last-child) {
									border-bottom: 1px solid $c-gray-light;
								}
								&.require {
									.label {
										position:relative;
										&:after {
											display:inline-block;
											position:absolute;
											top:-4px;
											color:#f9153c;
											content:'*';
										}
									}
								}
								&.emailGroup {
									.control {
										width:222px;
										&.emailSelect {
											margin-left:10px;

											.select {
												width:100%;
												// height:50px;
												select {
													width:100%;
													height:100%;
													border:0;
													background:transparent;
												}
											}
										}
									}
									.at {
										margin:0 10px;
									}
								}
								.label {
									flex-basis:18.34%;
									margin:0;
									padding-left:30px;
									color:$c-gray-dark;
									font-size:$text-normal;
								}
								.informationInputContent {
									display:flex;
									align-items:center;
									flex-basis:81.66%;
								}
								.categoryFieldWrap {padding-bottom: 0;}
								.categoryField {
									height: auto;
									.chainedRadioToggle .b-radio {
										margin-right: 0;
									}
								}
								.control {
									// width: 100%;
									.input {
										width: 480px;
										height: 50px;
										border: 1px solid $c-gray-light2;
										border-radius: 4px;
										background: $c-gray-bright;
										box-shadow: none;
										color: $c-gray-dark;
										font-size: $title-tiny;
									}

									.select {
										// width:480px;
										height:50px;
										border:1px solid $c-gray-light2;
										border-radius:4px;
										background:$c-white;
										box-shadow:none;

										select {
											width:100%;
											height:100%;
											border:0;
											background:transparent;
											box-shadow:none;
											color:$c-gray-dark;
											font-size:$title-tiny;
										}
									}
								}
								&.textareaArticle {
									height:100%;
									margin:12px 0;
									.label {
										align-self:flex-start;
									}
									.control {
										.textarea  {
											width:100%;
											height:100%;
											border:1px solid $c-gray-light2;
											border-radius:4px;
											background:$c-gray-bright;
											box-shadow:none;
											color:$c-gray-dark;
											font-size:$title-tiny;
										}
									}
								}
								&.withMessage {
									.control {
										display:flex;
										align-items:center;
										flex-basis:100%;

										.input  {
											width:83%;
										}
										.textarea  {
											display:inline-flex;
											max-width:83%;
											min-width:83%;
											height:262px;
										}
										.help {
											display:inline-flex;
											visibility:visible !important;
											float:none;
											margin:0 0 0 36px;
											color:$c-gray-m;
											font-size:$text-tiny;
											&.counter {
											}
										}
									}
									&.textareaArticle {
										.control {
											align-items:flex-end;
											.help {
												margin-bottom:18px;
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
}
@media (max-width: 1024px) and (min-width: 742px) {
	.customerService {
		.customerServiceWrap {
			.pageContentWrap {
				.pageInnerContentHtmlWrap {
					.pageCustomerWrap {
						.informationInputWrap {
							.informationInputItem {
								&> .field {
									height:auto;
									padding:14px 0;

									&.emailGroup {
										.field {
											height:auto;
											.informationInputContent {
												flex-wrap:wrap;
												.emailSelect {
													width:480px;
													margin:10px 0 0 0;
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
}
@media (max-width: 741px) and (min-width: $mnWMobile) {
	.customerService {
		.customerServiceWrap {
			.pageContentWrap {
				.pageInnerContentHtmlWrap {
					.pageCustomerWrap {
						.control-label {
							font-size: $text-tiny;
						}
						.informationInputWrap {
							.informationInputItem {
								.field {
									flex-basis:100%;
									height:75px;
									margin:0; padding: 10px 0;
									&:not(:last-child) {
										border-bottom: 1px solid $c-gray-light;
									}
									&.require {
										.label {
											flex-basis: auto;
											margin-bottom: 6px; padding-left: 0;
											font-size: $title-xtiny;
										}
									}
									.control {
										$w: 100%;
										$h: 38px;
										.input {
											width: $w;
											height: $h;
											border-radius: 4px;
											font-size: $title-xtiny;
										}

										.select {
											width: $w/2;
											height: $h;
											border-radius: 4px;

											select {
												font-size: $title-xtiny;
											}
										}
									}
									.label {
										flex-basis: auto;
										margin-bottom: 6px; padding-left: 0;
										font-size: $title-xtiny;
									}
									&.withMessage {
										.control {
											.input  {
												width:100%;
											}
											.textarea  {
												max-width: 100%;
												min-width: 100%;
												height:202px;
												font-size: $text-small;
											}
											.help {
												margin-left: auto;
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
}
</style>

<style lang="scss" scoped>
@import '@/css/variables.scss';
.customerService {
	position: relative;
	padding-top: 88px;
	height: auto;
	width: 100%;
	background-color: $c-white;
	.customerServiceWrap {
		position: relative;
		width: 100%;
		margin: 0 auto;
		padding: 0;
		.topBgWrap {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 284px;
			z-index: 0;
		}
		.pageContentWrap {
			position: relative;
			margin: 0 auto;
			.pageTitleWrap{
				position: relative;
				padding: 74px 0;
				height: 284px;
				.titleTxt {
					color: $c-white; font-size: $title-medium; font-weight: bold;
				}
				.subTxt {
					color: $c-gray-light; font-size: $text-normal;
				}
				.imgWrap {
					position: absolute;
					height: 80%;
					width: 30%;
					top: 10%;
					left: 40%;
					img {
						height: 100%;
						width: auto;
						max-width: none;
					}
				}
			}
			.pageHeaderBoxWrap {
				$pd: 40px;
				$h: 176px;
				$maxR: 60%;
				$maxL: 100% - $maxR;
				position: relative;
				padding: $pd;
				border-radius: 8px;
				height: $h;
				box-shadow: 0x 3px 6px rgba(0,0,0,0.16);
				margin-bottom: 24px;
				.pageHeaderTitle {
					color: $c-white;
					font-size: $title-small;
					max-width: $maxL;
				}
				.pageHeaderBtns {
					max-width: $maxL;
					.btnLink {
						@include transition(0.3s);
						background-color: transparent;
						color: rgba($c-white, 0.8);
						margin-left: 10px;
						&:hover,
						&:focus {
							color: rgba($c-white, 1);
							background-color: rgba(0,0,0,0.12);
						}
					}
				}
				.pageHeaderTxt {
					color: $c-white;
					font-size: $text-small;
					max-width: $maxR;
				}
			}
			.pageInnerContentHtmlWrap {
				padding-bottom: 80px;
				/* page content area */
				.pageCustomerWrap {
					margin-top:62px;

					h3 {
						color:#282a2b;
						font-size:26px;
						font-weight:bold;
					}
					.userAgreementText {
						margin:22px 0 17px;
						border:1px solid #c4c4c4;
						background:#f6f6f6;

						.userAgreementTextInner {
							overflow-y:auto;
							height:220px;
							padding:28px;
						}
						p {
							color:$c-gray-dark;
							font-size:$title-xtiny;
							line-height:28px;
						}
					}

					.informationInputWrap {
						.informationInputHeader {
							display:flex;
							align-items:center;
							justify-content:space-between;
							margin-top:42px;
							h3 {
							}
							.require {
								color:#f9153c;
								font-size:$text-tiny;
							}
						}
						.informationInputItem {
							margin-top:14px;
							border-top:4px solid $c-gray-m;
							border-bottom:1px solid $c-gray;
						}
					}
					.btnWrap {
						margin-top:29px;
						text-align:right;
						.btnRegister {
							width:276px;
							height:82px;
							background:$c-gray-dark;
							color:$c-white;
							font-size:26px;
							font-weight:bold;
						}
					}
				}
			}
		}
	}
}
@media (max-width: 1024px) and (min-width: 742px) {
	.customerService {
		.customerServiceWrap {
			.pageContentWrap {
				width: 100%;
				padding: 0 20px 40px;
				.pageInnerContentHtmlWrap {
					padding-bottom: 0;
				}
			}
		}
	}
}
@media (max-width: 741px) and (min-width: $mnWMobile) {
	.customerService {
		.customerServiceWrap {
			.topBgWrap {
				height: 187px;
			}
			.pageContentWrap {
				.pageTitleWrap {
					height: auto;
					padding: 62px 20px;
					text-align: center;
					.subTxt {
						font-size: $text-tiny;
					}
					.titleTxt {
						font-size: $title-small;
					}
				}
				.pageInnerContentHtmlWrap {
					padding-bottom: 0;
					.pageCustomerWrap {
						margin-top: 40px; padding: 0 12px 40px;
						h3 {
							font-size: $text-normal-small;
						}
						.userAgreementText {
							margin: 10px 0 16px;
							.userAgreementTextInner {
								height: 90px;
								padding: 14px;
							}
							p {
								line-height: 1.5em;
								font-size: $text-tiny;
							}
						}
						.informationInputWrap {
							.informationInputItem {
								margin-top: 6px;
								border-top: 2px solid #747474;
								&> .field {
									flex-wrap:wrap;
									height:auto;
									padding: 10px 0;
									.label {
										margin:0 0 10px 0;
										padding:0;
									}
									.label,
									.informationInputContent {
										flex-basis:100%;
										.control {
											flex:1;
											.input,
											.select {
												width:100%;
											}
										}
									}
									&.emailGroup {
										.at {
											margin: 0 6px;
										}
										.field {
											flex-wrap:wrap;
											height:auto;
											.informationInputContent {
												flex-wrap:wrap;
												justify-content:space-between;
												.control {
													flex:0 0 44%;
												}
												.emailSelect {
													flex: 1;
													margin: 6px 0 0 0;
												}
											}
										}
									}
									.categoryField {
										padding-top: 0;
									}
									&.textareaArticle {
										margin:0;
									}
									&.withMessage {
										.control {
											flex-wrap:wrap;

											.input  {
												width:100%;
											}
											.textarea  {
												display:block;
												max-width:100%;
												min-width:100%;
												height:262px;
											}
											.help {
												display:block;
												visibility:visible !important;
												float:none;
												width:100%;
												margin:10px 0 0 0;
												color:$c-gray-m;
												font-size:$text-tiny;
												text-align:right;
											}
										}
										&.textareaArticle {
											.control {
												.help {
													margin-bottom:0;
												}
											}
										}
									}
								}
							}
						}
						.btnWrap {
							margin-top: 32px;
							.btnRegister {
								width:100%;	height: 56px;
								font-size: $text-normal;
							}
						}
					}
				}
			}
		}
	}
}
</style>
